import { jsx as s, jsxs as E, Fragment as j } from "react/jsx-runtime";
import { Label as S } from "../../label/Label/Label.js";
import { cn as u } from "@deputy-ai/common";
import { Slot as O } from "radix-ui";
import * as m from "react";
import { FormProvider as V, Controller as k, useFormContext as q } from "react-hook-form";
export * from "react-hook-form";
const $ = m.createContext(
  {}
);
function w(e) {
  const { children: r, name: t, ...o } = e, i = m.useMemo(() => ({ name: t }), [t]);
  return /* @__PURE__ */ s($.Provider, { value: i, children: /* @__PURE__ */ s(k, { ...o, name: t, render: r }) });
}
function P() {
  const e = m.useContext($), r = m.useContext(L), { getFieldState: t, formState: o } = q(), i = t(e.name, o);
  if (!e)
    throw new Error("useFormField should be used within <FormField>");
  const { id: n } = r;
  return {
    id: n,
    name: e.name,
    formItemId: `${n}-form-item`,
    formDescriptionId: `${n}-form-item-description`,
    formMessageId: `${n}-form-item-message`,
    ...i
  };
}
const L = m.createContext(
  {}
);
function z(e) {
  const { className: r, ...t } = e, o = m.useId();
  return /* @__PURE__ */ s(L.Provider, { value: { id: o }, children: /* @__PURE__ */ s(M, { className: u("space-y-2", r), ...t }) });
}
function M(e) {
  const { className: r, ...t } = e;
  return /* @__PURE__ */ s("div", { className: u("space-y-2", r), ...t });
}
function A(e) {
  const { className: r, ...t } = e, { formItemId: o } = P();
  return /* @__PURE__ */ s(S, { className: r, htmlFor: o, ...t });
}
function B(e) {
  const { error: r, formItemId: t, formDescriptionId: o, formMessageId: i } = P();
  return /* @__PURE__ */ s(
    O.Root,
    {
      id: t,
      "aria-describedby": r ? `${o} ${i}` : o,
      "aria-invalid": !!r,
      ...e
    }
  );
}
function G(e) {
  const { formDescriptionId: r } = P();
  return /* @__PURE__ */ s(R, { id: r, ...e });
}
function R(e) {
  const { className: r, ...t } = e;
  return /* @__PURE__ */ s(
    "p",
    {
      className: u("text-muted-foreground text-[0.8rem]", r),
      ...t
    }
  );
}
function H(e) {
  const { children: r, ...t } = e, { error: o, formMessageId: i } = P(), n = o ? (o == null ? void 0 : o.message) ?? "" : r;
  return n ? /* @__PURE__ */ s(U, { id: i, ...t, children: n }) : null;
}
function U(e) {
  const { className: r, children: t, ...o } = e;
  return /* @__PURE__ */ s(
    "p",
    {
      className: u("text-destructive text-[0.8rem] font-medium", r),
      ...o,
      children: t
    }
  );
}
function J(e) {
  const {
    watch: r,
    getValues: t,
    getFieldState: o,
    setError: i,
    clearErrors: n,
    setValue: l,
    trigger: a,
    formState: c,
    resetField: b,
    reset: p,
    handleSubmit: x,
    unregister: C,
    control: f,
    register: v,
    setFocus: N,
    subscribe: D,
    ...d
  } = e, F = {
    watch: r,
    getValues: t,
    getFieldState: o,
    setError: i,
    clearErrors: n,
    setValue: l,
    trigger: a,
    formState: c,
    resetField: b,
    reset: p,
    handleSubmit: x,
    unregister: C,
    control: f,
    register: v,
    setFocus: N,
    subscribe: D
  }, { children: h, ...I } = d;
  return /* @__PURE__ */ s(V, { ...F, children: /* @__PURE__ */ s("form", { ...I, children: h }) });
}
function K(e) {
  const {
    // fieldProvider
    name: r,
    rules: t,
    shouldUnregister: o,
    defaultValue: i,
    control: n,
    disabled: l,
    children: a,
    // label
    label: c,
    labelProps: b,
    // description
    description: p,
    descriptionProps: x,
    // messageProps
    messageProps: C,
    // item
    renderItem: f,
    ...v
  } = e, N = {
    name: r,
    rules: t,
    shouldUnregister: o,
    defaultValue: i,
    control: n,
    disabled: l
  };
  function D(...d) {
    const F = c && /* @__PURE__ */ s(g.Label, { ...b, children: c }), h = p && /* @__PURE__ */ s(g.Description, { ...x, children: p }), I = /* @__PURE__ */ s(g.Message, { ...C }), y = a(...d);
    return f ? f({
      label: F,
      description: h,
      message: I,
      children: y
    }) : /* @__PURE__ */ E(j, { children: [
      F,
      y,
      h,
      I
    ] });
  }
  return /* @__PURE__ */ s(w, { ...N, children: (...d) => /* @__PURE__ */ s(g.Item, { ...v, children: D(...d) }) });
}
function Q(e) {
  const {
    label: r,
    labelProps: t,
    description: o,
    descriptionProps: i,
    message: n,
    messageProps: l,
    children: a,
    ...c
  } = e;
  return /* @__PURE__ */ E(M, { ...c, children: [
    r && /* @__PURE__ */ s(S, { ...t, children: r }),
    a,
    o && /* @__PURE__ */ s(R, { ...i, children: o }),
    n && /* @__PURE__ */ s(U, { ...l, children: n })
  ] });
}
function T(e) {
  const { className: r, children: t, ...o } = e;
  return /* @__PURE__ */ s("div", { className: u("text-primary-600 text-sm", r), ...o, children: t });
}
const g = Object.assign(J, {
  Provider: V,
  FieldRoot: w,
  Item: z,
  ItemUI: M,
  Label: A,
  Control: B,
  Description: G,
  Message: H,
  MessageUI: U,
  Field: K,
  FieldUI: Q,
  ValueDisplay: T
});
export {
  g as Form,
  P as useFormField
};
